import React from 'react';

interface HighlighterProps {
  text: string;
  highlight?: string;
  color?: string;
}

export const getHighlightedValue = ({ text, highlight, color = 'yellow' }: HighlighterProps): React.ReactNode => {
  if (!highlight) {
    return text;
  }
  // Escape all characters in Regex otherwise match is not highlighted
  const splitWord = highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').split(' ');
  // \s* - represent any whitespace characters zero to unlimited times
  const regex = new RegExp(splitWord.join('\\s*'), 'gi');

  const matches = text.match(regex);

  if (!matches || matches.length === 0) {
    return text;
  }

  const parts = text.split(regex);

  return parts
    .map((it, index) => {
      const subParts: React.ReactNode[] = [];
      if (it !== '') {
        subParts.push(<span key={index + '-pre-highlight'}>{it}</span>);
      }
      // Add highlighted match. Except for the last part as there are -1 matches as there are split parts.
      if (index !== parts.length - 1) {
        subParts.push(
          <span key={index + '-highlight'} style={{ backgroundColor: color }}>
            {matches[index]}
          </span>
        );
      }
      return subParts;
    })
    .flat(1);
};
const getMultiHighlightRegex = (text: string): RegExp => {
  const escapedString = text.replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&');
  const parts = escapedString.split(' ').map((w) => w.toLowerCase());
  return new RegExp(`(${parts.join('|')})`, 'gi');
};

export const getHighlightedText = ({ text, highlight, color = 'yellow' }: HighlighterProps) => {
  if (!highlight) {
    return text;
  }
  const highlightedWords = highlight.split(' ').map((word) => word.toLowerCase());

  const parts = text.split(getMultiHighlightRegex(highlight));
  return parts.map((part, i) => {
    return (
      <span
        key={i + '-highlight'}
        style={highlightedWords.includes(part.toLowerCase()) ? { backgroundColor: color } : {}}
      >
        {part}
      </span>
    );
  });
};
